import { getActionHookBuilder } from '@mm/state/actions/action-hook-builder';
import { Dispatch } from 'redux';
import { StoreState } from '../../store-interfaces';

const ACTIONS_NAMESPACE = 'CONNECTIONS_TABLE';

export const SET_CONNECTIONS_ORDER_BY = `${ACTIONS_NAMESPACE}__SET_CONNECTIONS_ORDER_BY`;
export const SET_ACTIVE_INTEGRATION = `${ACTIONS_NAMESPACE}__SET_ACTIVE_INTEGRATION`;
export const RESET_STATE = `${ACTIONS_NAMESPACE}__RESET_STATE`;

export const MAILCHIMP = 'mailchimp';
export const GOOGLE_SHEET = 'google_sheet';
export const FACEBOOK_ADS = 'facebook_ads';
export const GOOGLE_ADS = 'google_ads';

export function setConnectionsOrderBy(connectionsOrderBy) {
  return (dispatch: Dispatch<StoreState>) => {
    dispatch({
      type: SET_CONNECTIONS_ORDER_BY,
      payload: { connectionsOrderBy },
    });
  };
}

export function setActiveIntegration(integrationName?: string) {
  return (dispatch: Dispatch<StoreState>) => {
    dispatch({
      type: SET_ACTIVE_INTEGRATION,
      payload: { activeIntegration: integrationName },
    });
  };
}

export function resetState() {
  return (dispatch: Dispatch<StoreState>) => {
    dispatch({
      type: RESET_STATE,
    });
  };
}

const actions = { setConnectionsOrderBy, setActiveIntegration, resetState };

export default actions;

export const useConnectionsTableActions = getActionHookBuilder(actions, [
  'setConnectionsOrderBy',
  'setActiveIntegration',
  'resetState',
]);
